import React from "react";

import ConsignmentList from "../consignmentList";

const ConsignmentListTracking = () => <ConsignmentList sentList trackingList />;

export default ConsignmentListTracking;
